import { InputAdornment } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { StyledAutoComplete } from 'components/AutoCompleteFilter/styles';
import { AssuranceIcon } from 'images';
import React from 'react';

const filterOptions = (filterKey: string) =>
  createFilterOptions({
    matchFrom: 'any',
    stringify: (option: any) => option[filterKey],
  });

interface Props {
  name: string;
  value: any;
  options: any[];
  onChange: (value: any) => any;
  handleBlur?: Function;
  onInputChange?: (value: string) => void;
  loading?: boolean;
  label?: string;
  placeholder?: string;
  filterKey?: string;
  minInputLength?: number;
  renderOption?: (option: any) => React.ReactNode | string;
  getOptionSelected?: (option: any, value: any) => boolean;
  getOptionLabel?: (option: any) => string;
  noOptionsText?: string | React.ReactNode;
  error?: boolean;
  helperText?: string;
}

const AutoComplete = (props: Props) => {
  const {
    name,
    options,
    loading,
    label,
    placeholder,
    value,
    onChange,
    onInputChange,
    renderOption = (option: any) => option.label,
    getOptionSelected = (option: any, value: any) => option.id === value.id,
    getOptionLabel = (option: any) => option.label,
    filterKey = 'label',
    error = false,
    helperText = '',
    ...rest
  } = props;

  return (
    <StyledAutoComplete
      data-testid="autocomplete"
      id="autocomplete"
      getOptionSelected={getOptionSelected}
      getOptionLabel={getOptionLabel}
      options={options}
      loading={loading}
      onChange={(_, _value) => onChange(_value)}
      value={value}
      renderOption={renderOption}
      onInputChange={(_, value) => onInputChange && onInputChange(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          label={label}
          variant="outlined"
          name={name}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <img
                  style={{ marginLeft: 4 }}
                  src={AssuranceIcon.searchIcon}
                  alt="search icon - saham assurance"
                />
              </InputAdornment>
            ),
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      filterOptions={filterOptions(filterKey)}
      fullWidth
      clearOnBlur
      {...rest}
    />
  );
};

export default AutoComplete;
